import Link from 'next/link';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Dropdown from '@deprecated-ui/calendar/Dropdown';
import DATA_CY from 'constants/data-cy';
import { CALENDAR_MENU_ITEMS } from 'features/calendar/constants';
import { HorizontalMenu, MoreMenu } from './styled';
import VerticalMenu from './VerticalMenu';

const HeaderMenu = ({ activeMenu }: { activeMenu: string }) => (
  <>
    {/* @ts-expect-error */}
    <HorizontalMenu
      mode="horizontal"
      defaultSelectedKeys={activeMenu}
      selectedKeys={activeMenu}
    >
      {CALENDAR_MENU_ITEMS.slice(0, 9).map((menu) => (
        <HorizontalMenu.Item key={menu}>
          <Link
            href={`/calendar/${
              menu.toLowerCase() === 'today'
                ? ''
                : menu.split(' ').join('').toLowerCase()
            }`}
            passHref
          >
            <Text color="inherit" align="center" padding="8px 5px">
              {menu}
            </Text>
          </Link>
        </HorizontalMenu.Item>
      ))}
      <HorizontalMenu.Item key="navigation-vertical">
        <Dropdown
          overlay={
            <VerticalMenu
              selectedMenu={activeMenu}
              verticalMenuItems={CALENDAR_MENU_ITEMS.slice(9)}
            />
          }
          placement="bottomRight"
          // @ts-expect-error
          style={{ order: 8 }}
        >
          <Flex align="center" data-cy={DATA_CY.CALENDAR.HEADER_MORE_BUTTON}>
            <MoreMenu isDesktopMenu />
          </Flex>
        </Dropdown>
      </HorizontalMenu.Item>
    </HorizontalMenu>
  </>
);

export default HeaderMenu;
